module.exports = __webpack_public_path__ + "img/symbol_6.b8ff101d.png";